import SchoolPricingPlan from './SchoolPricingPlan.component';

export default SchoolPricingPlan;
